// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"81af06e8","941":"962cc94e"}[chunkId] + ".chunk.js";
};